import { makeStyles } from '@rbx/ui';
import { rightNavWidth } from '@modules/layout/layout/constants/layoutConstants';

const useCourseProgressBarStyles = makeStyles()((theme) => ({
  container: {
    minWidth: rightNavWidth,
    maxWidth: rightNavWidth,
    display: 'flex',
    flexDirection: 'column',
    height: '90vh',
    paddingLeft: '16px',
    paddingBottom: '100px',
    overflow: 'hidden',
  },
  scrollableContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  stepper: {
    '& .MuiStepContent-root': {
      marginLeft: '12px',
      paddingLeft: '0px',
    },
  },
  stepContent: {
    display: 'block',
  },
  clickableMilestone: {
    cursor: 'pointer',
  },
  lessonList: {
    padding: 0,
    width: '100%',
    marginBottom: 0,
  },
  lessonLink: {
    textDecoration: 'none',
    width: '100%',
    underline: 'none',
  },
  checkLesson: {
    marginLeft: '4px',
    verticalAlign: 'text-top',
  },
  alert: {
    position: 'fixed',
    left: '50%',
    bottom: '50px',
    transform: 'translateX(-50%)',
    zIndex: 1000,
  },
  titleAndMenu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '24px',
  },
  mobileTitleAndMenu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px',
  },
}));

export default useCourseProgressBarStyles;
